import React from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

import { formatDate } from "../utils/functions";
import { RoutesNames } from "../utils/routes";

import {
  ContainField,
  ContainerRow,
  TextAffiliateStatus,
  TextPendingStatus,
  TextUnaffiliatedStatus,
} from "../../styles/PageStyles/Health/stylesRegistersHealth";

const OptionHealth = ({ item }) => {
  const navigate = useNavigate();

  const handleGoDetail = () => {
    navigate(RoutesNames.DetailHealth, { state: { item } });
  };

  const getStatus = () => {
    if (item.isAffiliated === "AFFILIATE") {
      return <TextAffiliateStatus>Afiliado(a)</TextAffiliateStatus>;
    } else if (item.isAffiliated === "PENDING_REQUEST") {
      return <TextPendingStatus>Pendiente</TextPendingStatus>;
    } else {
      return <TextUnaffiliatedStatus>No afiliado(a)</TextUnaffiliatedStatus>;
    }
  };

  return (
    <ContainerRow onClick={handleGoDetail}>
      <ContainField style={{ cursor: "pointer" }}>{getStatus()}</ContainField>
      <ContainField>{formatDate(item?.created)}</ContainField>
      <ContainField>{item?.firstName}</ContainField>
      <ContainField>{item?.lastName}</ContainField>
      <ContainField>{item?.state.name}</ContainField>
      <ContainField>{item?.city.name}</ContainField>
    </ContainerRow>
  );
};

OptionHealth.propTypes = {
  item: PropTypes.object.isRequired,
  healthId: PropTypes.string,
  updateStatusHealth: PropTypes.func,
  setHealthId: PropTypes.func,
};

export default OptionHealth;
